import { render } from "./FullscreenDocument.vue?vue&type=template&id=1c84d355&scoped=true"
import script from "./FullscreenDocument.vue?vue&type=script&lang=js"
export * from "./FullscreenDocument.vue?vue&type=script&lang=js"

import "./FullscreenDocument.vue?vue&type=style&index=0&id=1c84d355&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c84d355"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QBtn,QImg,QInnerLoading});
